<template>
  <div class="mr-2 ml-0">
    <v-expansion-panels flat multiple>
      <v-expansion-panel
        v-for="(filter, index) in arrFilters"
        :key="index"
      >
        <v-expansion-panel-header class="pa-0" color="#FAFAFA"><h4>{{ filter.title }}</h4></v-expansion-panel-header>
          <ais-refinement-list
            searchable
            :attribute="filter.attribute"
            operator="or"
            :limit="filter.limit != null ? filter.limit : 20"
            :sort-by="['isRefined']"
          >
            <div slot-scope="{
              items,
              isFromSearch,
              refine,
              searchForItems
            }">
              <v-expansion-panel-content color="#FAFAFA">
                <v-text-field
                  prepend-inner-icon="search"
                  :label="$t('search')"
                  class="box-search-box ml-0"
                  hide-details
                  solo
                  @input="handleSearch(searchForItems.bind(null, $event), $event)"
                />
                <span v-if="isFromSearch && !items.length">{{ $t('orders.no_results') }}</span>
                <v-checkbox
                  class="mt-1"
                  v-for="item in items"
                  :key="item.value"
                  color="kazan"
                  hide-details
                  v-model="item.isRefined"
                  @change="handleRefinment(refine.bind(null, item.value), searchForItems)"
                >
                <template v-slot:label>
                  <span
                    v-if="filter.colorMap"
                    class="coloredCircle"
                    :style="'background-color: ' + filter.colorMap[item.label]"
                  ></span>
                  <span v-if="filter.i18nPreffix">
                  {{ $t(filter.i18nPreffix + item.value) }}
                  </span>
                  <span v-else>
                    <ais-highlight :class-names="{'ais-Highlight-highlighted': 'ais-highlighted'}" attribute="item" :hit="item"/>
                    <!-- {{item.label}} -->
                  </span>
                  <v-chip
                    v-if="!filter.hideNumber"
                    small
                    class="chip-style"
                  >{{ item.count.toLocaleString() }}</v-chip>
                </template>
              </v-checkbox>
            </v-expansion-panel-content>
          </div>
        </ais-refinement-list>
    </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>

export default {
  name: 'AlgoliaSelectableFilters',
  props: {
    arrFilters: Array
  },
  data () {
    return {
      searchValue: null
    }
  },
  methods: {
    handleSearch (callback, value) {
      this.searchValue = value
      callback()
    },
    handleRefinment (callback, searchForItems) {
      callback()
      if (this.searchValue != null) {
        setTimeout(() => {
          searchForItems(this.searchValue)
        }, 200)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .v-expansion-panel {
    box-shadow: none;
    background: transparent;
    // margin-bottom: 15px;
  }
  .theme--light.v-expansion-panel .v-expansion-panel__container {
    background: transparent;
  }
  ::v-deep .v-expansion-panel__body {
    border-bottom: 1px lightgray solid;
  }
  ::v-deep .v-expansion-panel__header {
    padding: 0;
    background: transparent;
    min-height: 35px;
  }
  ::v-deep .v-expansion-panel label {
    font-size: 14px;
  }
  .coloredCircle {
    height: 12px;
    width: 12px;
    border-radius: 50%;
    margin-right: 5px;
  }
  ::v-deep .ais-Highlight mark {
        background-color: transparent;
        font-weight: 800;
  }
  .chip-style {
    background-color: #FAFAFA;
    color: #787878;
  }
</style>
